import { useMemo } from 'react';
import {
  LayoutDashboard,
  Building2,
  Activity,
  Package,
  Languages,
  Globe,
  Settings
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PATHS } from '../../../router/paths.ts';
import { SidebarShell } from '../app-shell/sidebar-shell.tsx';
import { NavItemRow, type NavItemDef } from '../app-shell/nav-item-row.tsx';

export default function SideNavAdmin() {
  const { t } = useTranslation();

  const navItems = useMemo<NavItemDef[]>(
    () => [
      {
        name: t('dashboard'),
        href: PATHS().ADMIN_DASHBOARD,
        icon: LayoutDashboard
      },
      {
        name: t('organizations'),
        href: PATHS().ADMIN_ORGANIZATIONS,
        icon: Building2
      },
      { name: t('operations'), href: PATHS().ADMIN_OPERATIONS, icon: Activity },
      { name: t('plans'), href: PATHS().ADMIN_PLANS, icon: Package },
      { name: t('languages'), href: PATHS().ADMIN_LANGUAGES, icon: Languages },
      { name: t('translation'), href: PATHS().ADMIN_TRANSLATION, icon: Globe },
      { name: t('settings'), href: PATHS().ADMIN_SETTINGS, icon: Settings }
    ],
    [t]
  );

  return (
    <SidebarShell
      navSlot={
        <ul role="list" className="m-0 p-0 space-y-0.5">
          {navItems.map(item => (
            <NavItemRow key={item.href} item={item} />
          ))}
        </ul>
      }
    />
  );
}
